export const VERTICAL_TICK_DIST = 240;
export const HORIZONTAL_TICK_DIST = 50;
export const TRANSITION = 200;
export const GRID_SIZE = 16;
export const GRID_COLOR = "rgba(150, 150, 160, 0.2)";
export const LABEL_COLOR = "rgba(150, 150, 180, 1)";
